/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContainerSelectItemDto } from '../../models/container-select-item-dto';

export interface GetContainerSelectItemsFromSortiment$Params {
  subType: string;
}

export function getContainerSelectItemsFromSortiment(http: HttpClient, rootUrl: string, params: GetContainerSelectItemsFromSortiment$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContainerSelectItemDto>>> {
  const rb = new RequestBuilder(rootUrl, getContainerSelectItemsFromSortiment.PATH, 'get');
  if (params) {
    rb.query('subType', params.subType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContainerSelectItemDto>>;
    })
  );
}

getContainerSelectItemsFromSortiment.PATH = '/sortiments/containers/select-items';
